import { render, staticRenderFns } from "./TooManyAttemptsModal.vue?vue&type=template&id=16791cf8"
import script from "./TooManyAttemptsModal.vue?vue&type=script&lang=js"
export * from "./TooManyAttemptsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports